import * as DropdownMenuPrimitive from '@radix-ui/react-dropdown-menu'
import { FC } from 'react'
import { styled } from '../../lib/stitches'
import { gray1, gray12, gray3, gray4 } from '../platform/color'
import { Column } from './Components'

const DropdownMenuItem = styled(DropdownMenuPrimitive.Item, {
  display: 'flex',
  alignItems: 'center',
  padding: '9px 15px',
  cursor: 'pointer',
  '&:hover': {
    border: 'none',
    textDecoration: 'underline',
    outline: 'none'
  }
})

const DropdownMenuSeparator = styled('div', {
  height: '1px',
  width: '100%',
  backgroundColor: gray4,
  margin: '14px 0px'
})

const StyledDropdownMenuArrow = styled(DropdownMenuPrimitive.Arrow, {
  fill: gray1
})

const StyledDropdownMenuContainer = styled(Column, {
  minWidth: '200px',
  borderRadius: '20px',
  backgroundColor: gray1,
  padding: '20px 20px',
  color: gray12,
  fontSize: '14px',
  fontWeight: 600,
  fontFamily: 'DM Sans, sans-serif',
  border: `1px solid ${gray3}`,
  boxShadow: '0px 1px 20px rgba(24, 15, 85, 0.1)'
})

interface DropdownMenuProps {
  trigger: any
  children: any
  containerStyle?: {}
  open?: boolean
  onOpenChange?: (open: boolean) => void
}

const DropdownMenuBody: FC<DropdownMenuProps> = (props) => {
  return (
    <DropdownMenuPrimitive.Root {...props} modal={false} dir="ltr">
      <DropdownMenuPrimitive.Trigger asChild={true}>{props.trigger}</DropdownMenuPrimitive.Trigger>
      <DropdownMenuPrimitive.Portal>
        <DropdownMenuPrimitive.Content sideOffset={5} align="end" style={{ zIndex: 100 }}>
          <StyledDropdownMenuArrow width={20} height={12} offset={25} />
          <StyledDropdownMenuContainer css={props.containerStyle}>
            {props.children}
          </StyledDropdownMenuContainer>
        </DropdownMenuPrimitive.Content>
      </DropdownMenuPrimitive.Portal>
    </DropdownMenuPrimitive.Root>
  )
}

const DropdownMenu = {
  Body: DropdownMenuBody,
  Item: DropdownMenuItem,
  Separator: DropdownMenuSeparator
}

export default DropdownMenu
